"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isNumber = _interopRequireDefault(require("lodash/fp/isNumber"));
var _number = require("@active/core/number");
var toFixedPoint = function toFixedPoint(fixedPoint) {
  return {
    test: function test(source) {
      return (0, _isNumber["default"])(fixedPoint) && fixedPoint >= 0 && (0, _number.isDecimal)(source) && (0, _number.decimalCountOf)(source) > fixedPoint;
    },
    processNumber: function processNumber(_ref) {
      var source = _ref.source,
        caret = _ref.caret;
      return {
        source: (0, _number.toFixed)(fixedPoint, {
          roundUp: false
        })(source),
        caret: caret
      };
    }
  };
};
var _default = exports["default"] = toFixedPoint;